import { Axis } from '@types'
import { toVector3 } from '@utils/conversion/toVector3'
import { Matrix4, Mesh } from 'three'

export function addItemOffset(referenceMatrix: Matrix4, offset: number, axis: Axis) {
  const vectorXAxis = toVector3()
  const vectorYAxis = toVector3()
  const vectorZAxis = toVector3()
  const newObject = new Mesh()
  const referenceObject = new Mesh()

  referenceObject.applyMatrix4(referenceMatrix)
  newObject.position.copy(referenceObject.position)
  newObject.rotation.copy(referenceObject.rotation)

  referenceObject.matrix.extractBasis(vectorXAxis, vectorYAxis, vectorZAxis)

  let offsetAxis = toVector3()

  switch (axis) {
    case 'x':
      offsetAxis = vectorZAxis
      break
    case 'y':
      offsetAxis = vectorYAxis
      break
    case 'z':
      offsetAxis = vectorXAxis
      break
    default:
      throw new Error('Invalid axis value')
  }

  newObject.position.add(offsetAxis.clone().setLength(offset))
  newObject.updateMatrix()

  return new Matrix4().copy(newObject.matrix)
}
